const csmstimetable = {
  namespaced: true,
  state: {
    applyObj: {},
  },
  mutations: {
    setApplyObj (state, applyObj) {//调代课申请的详情
      state.applyObj = applyObj;
    },
  },
}
export default csmstimetable
